export default __webpack_public_path__ + "static/media/drink.953922be.svg";